module.exports = __webpack_public_path__ + "static/media/boxing.d959c2cf.jpg";